import { useNotificationsContext } from "common/context/NotificationsProvider"
import { Button } from "primereact/button"

import { useTranslation } from "react-i18next"
import "../style.scss"

const NotificationsMenuListFooter = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'seeAllNotifications' does not exist on t...
  const { seeAllNotifications } = useNotificationsContext()

  return (
    <div className='notifications-menu-list-footer d-flex justify-content-center'>
      <Button
        className='p-button-text notifications-menu-actions w-100 d-flex justify-content-center'
        onClick={seeAllNotifications}
      >
        {t("notificationsMenu.footer.seeAll")}
      </Button>
    </div>
  )
}

export default NotificationsMenuListFooter
